<template>
    <svg width="33" height="33" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1 9.67708H17.2917M9.67708 18V1M3.125 18H15.875C17.0486 18 18 17.0486 18 15.875V3.125C18 1.95139 17.0486 1 15.875 1H3.125C1.95139 1 1 1.95139 1 3.125V15.875C1 17.0486 1.95139 18 3.125 18Z"
            stroke="currentColor"
            stroke-width="1.5"
        />
    </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'IconBorderSetting',
})
</script>
